const tones = {
  default: { icon: 'text-zinc-400 bg-zinc-500/10', value: 'text-zinc-50' },
  accent: { icon: 'text-accent bg-accent/10', value: 'text-zinc-50' },
  success: { icon: 'text-success bg-success/10', value: 'text-success' },
  danger: { icon: 'text-danger bg-danger/10', value: 'text-danger' },
  info: { icon: 'text-info bg-info/10', value: 'text-zinc-50' },
  warning: { icon: 'text-warning bg-warning/10', value: 'text-zinc-50' },
};

export default function MetricCard({ label, value, icon: Icon, description, tone = 'default', loading = false }) {
  const toneStyle = tones[tone] || tones.default;

  return (
    <div className="group card p-4 transition duration-200 hover:border-white/[0.14] hover:bg-surface2">
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-medium uppercase tracking-wide text-zinc-500">{label}</p>
        {Icon && (
          <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${toneStyle.icon} transition duration-200 group-hover:scale-105`}>
            <Icon size={16} strokeWidth={2} />
          </span>
        )}
      </div>
      {loading ? (
        <div className="mt-2 h-8 w-24 animate-pulse rounded-md bg-surface2" />
      ) : (
        <p className={`mt-1.5 truncate font-display text-2xl font-semibold leading-tight tracking-tight sm:text-[1.75rem] ${toneStyle.value}`}>
          {value}
        </p>
      )}
      {description && (
        <p className="mt-1.5 truncate text-xs text-zinc-500">{loading ? '' : description}</p>
      )}
    </div>
  );
}
